import { MENTION_ID_PREFIX } from "./constants";

export function normalizeMentionId(mentionId: string): string {
	return mentionId.startsWith(MENTION_ID_PREFIX)
		? mentionId
		: `${MENTION_ID_PREFIX}${mentionId}`;
}

export function mentionIdsEqual(a: string, b: string): boolean {
	return normalizeMentionId(a) === normalizeMentionId(b);
}
